// Ytfärger för tabeller och statusrutor, i ljust och mörkt läge.
// Läggs i temat som palette.yta och palette.status, så att sx kan använda
// t.ex. bgcolor: 'yta.rubrik' eller color: 'status.overText'.
//
// rubrik/summa/rad är ogenomskinliga: de används även i klistrade (sticky)
// tabellkolumner, där innehållet annars syns igenom när man scrollar.

export function ytor(mode) {
  if (mode === 'dark') {
    return {
      yta: {
        rubrik: '#2c2c2e',       // tabellhuvud
        summa: '#242426',        // summarad
        rad: '#212123',          // varannan rad
        lila: '#2d2236',         // utfall
        lilaText: '#CE93D8',
        kalla: '#3a2a1c',        // markerad källkolumn (kopiering)
        mal: '#1c2a3a',          // markerad målkolumn
        spar: 'rgba(255,255,255,0.16)', // stapelbakgrund
      },
      status: {
        underBg: 'rgba(102,187,106,0.16)', underText: '#81C784',
        naraBg: 'rgba(255,167,38,0.16)', naraText: '#FFB74D',
        overBg: 'rgba(239,83,80,0.16)', overText: '#E57373',
        infoBg: 'rgba(66,165,245,0.16)', infoText: '#90CAF9',
      },
    };
  }
  return {
    yta: {
      rubrik: '#f5f5f5',
      summa: '#f9f9f9',
      rad: '#fafafa',
      lila: '#F3E5F5',
      lilaText: '#4A148C',
      kalla: '#FFF3E0',
      mal: '#E3F2FD',
      spar: '#e0e0e0',
    },
    status: {
      underBg: '#E8F5E9', underText: '#2e7d32',
      naraBg: '#FFF8E1', naraText: '#e65100',
      overBg: '#FFEBEE', overText: '#c62828',
      infoBg: '#E3F2FD', infoText: '#1565C0',
    },
  };
}
